import { PropsWithChildren, createContext, useContext } from 'react'

import { BACKEND_DATE_FORMAT, LOCAL_STORAGE_KEYS } from 'config/Vars'
import moment from 'moment'
import { useLocalStorage } from 'usehooks-ts'

export interface Filters {
  atsJobPostingIds: string[]
  teamIds: string[]
  startDateRange: string
  endDateRange: string
}

export interface FilterOption {
  label: string
  value: number | string
}

const lastMonth = moment().subtract(1, 'month')
export const DEFAULT_START_DATE = lastMonth.startOf('month').format(BACKEND_DATE_FORMAT)
export const DEFAULT_END_DATE = lastMonth.endOf('month').format(BACKEND_DATE_FORMAT)

const MetricsFiltersContext = createContext<{
  filters: Filters
  setFilters: (newFilters: Partial<Filters>) => void
} | null>(null)

export const MetricsFiltersProvider = ({ children }: PropsWithChildren) => {
  const DEFAULT_METRICS_FILTERS: Filters = {
    startDateRange: DEFAULT_START_DATE,
    endDateRange: DEFAULT_END_DATE,
    atsJobPostingIds: [],
    teamIds: [],
  }

  const [filters, _setFilters] = useLocalStorage(
    LOCAL_STORAGE_KEYS.atsInsightsFilters,
    DEFAULT_METRICS_FILTERS
  )

  const setFilters = (newFilters: Partial<Filters>) => {
    _setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }))
  }

  return (
    <MetricsFiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </MetricsFiltersContext.Provider>
  )
}

export function useMetricsFilters() {
  const currentMetricsFiltersContext = useContext(MetricsFiltersContext)

  if (!currentMetricsFiltersContext) {
    throw new Error('useMetricsFilters must be used within a MetricsFiltersProvider')
  }

  return currentMetricsFiltersContext
}
